export enum ACTIVITIES {
    calls = 'calls',
    dds = 'dds',
    uniqueCalls = 'uniqueCalls',
    earlyHangUps = 'earlyHangUps',
    sms = 'sms',
    pickUps = 'pickUps',
    convos = 'convos',
    offers = 'offers',
    dq = 'dq',
    sets = 'sets',
    triage = 'triage',
}

export enum EVENTS {
    left_voicemail = 'left_voicemail',
    consult_booked = 'consult_booked',
    consult_made = 'consult_made',
    triage_booked = 'triage_booked',
    no_answer = 'no_answer',
    connected = 'connected',
    dq = 'dq',
}
